export const commonLocalize = {
	addRecord: 'Pridať záznam',
	addRow: 'Pridať riadok',
	error: 'Vyskytla sa chyba. Prosím kontaktujte správcu: info@energy-monitor.eu.',
	noResults: 'Nenašli sa žiadne výsledky.',
	successChangedName: (endOfSentence) => `Úspešne ste zmenili názov ${endOfSentence}`,
	errorChangedName: (endOfSentence) => `Nepodarilo sa zmeniť názov ${endOfSentence}`,
	errValidationForm: 'Prosím skontrolujte, či sú všetky polia vyplnené správne.',
	unknown: 'Neznámy',
	close: 'Zavrieť',
	confirm: 'Potvrdiť',
	loading: 'Načítavam...',
	understood: 'Rozumiem'
}

export const inputFieldLocalize = {
	textIsEmpty: (textFieldName) => `Prosím vyplnte pole pre ${textFieldName}`,
	emailInvalid: 'Neplatný e-mail.',
	isNotNumber: 'Prosím zadajte číselnú hodnotu.',
	minStringLength: (value) => `Počet znakov musí byť min. ${value}`,
	maxStringLength: (value) => `Počet znakov može byť max. ${value}`,
	passwordMismatch: `Hesla sa nezhodujú`,
	valueInvalid: 'Zadaná hodnota nie je platná'
}

export const profileLocalize = {
	updateContactInfoSuccess: 'Úspešne ste uložili kontaktné informácie používateľa.',
	updateContactInfoErr: 'Nepodarili sa uložiť kontaktné informácie používateľa.',
	baseInfo: 'Základné informácie',
	successChangedPassword: 'Úspešne ste zmenili heslo.',
	errorChangedPassword: 'Nepodarilo sa zmeniť heslo.',
	generatedFileTemplates: 'Šablóny generovaných súborov',
	generatePreviewPdf: 'Generovať náhľad pdf',
	successUpdateSignature: 'Úspešne ste aktualizovali podpis.',
	errorUpdateSignature: 'Nepodarilo sa aktualizovať podpis.'
}

export const usersLocalize = {
	addUser: 'Nový používateľ',
	detailUser: (email) => `Detail používateľa [${email}]`,
	createdUserSuccessful: (email) => `Úspešne ste vytvorili pužívateľa s e-mailom: ${email}.`,
	createdUserErr: `Chyba! Nepodarilo sa vytvoriť pužívateľa.`,
	retrievingUsersErr: `Nepodarilo sa načítať pužívateľov.`
}

export const loginLocalize = {
	sendForgottenCodeError: 'Nepodarilo sa zaslať email pre obnovu hesla.',
	sendForgottenCodeSuccess: 'Na email sme Vám zaslali ďalšie info pre resetovanie hesla.'
}

export const houseCooperativeLocalize = {
	notFoundHouseCooperativeEntrance: 'Nenašli sa žiadne správcovské spoločnosťi ani vchody.',
	errorRetrievingHouseCooperativeEntrance: 'Nepodarilo sa načíťať správcovské spoločnosti ani vchody.',
	successAdd: (name) => `Úspešne ste pridali správcovskú spoločnosť s názvom: ${name}.`,
	successAssignToUser: (name) => `Úspešne ste zmenili priradenie správc-u/ov ku správcovskej spoločnosti s názvom: ${name}.`,
	errorAssignToUser: (name) => `Nepodarilo sa zmeniť priradenie správc-u/ov ku správcovskej spoločnosti s názvom: ${name}.`
}

export const entranceLocalize = {
	successAdd: (name) => `Úspešne ste pridali vchod s názvom: ${name}.`,
	successMove: (entranceName, hcName) => `Úspešne ste presunuli vchod s NÁZVOM: ${entranceName} do -> ${hcName}`,
	errorMove: (entranceName, hcName) => `Nepodarilo sa presunuť vchod s NÁZVOM: ${entranceName} do -> ${hcName}`,
	successAssignToUser: (name) => `Úspešne ste zmenili priradenie domovník-a/ov ku vchodu s názvom: ${name}.`,
	errorAssignToUser: (name) => `Nepodarilo sa zmeniť priradenie domovníka-a/ov ku vchodu s názvom: ${name}.`
}

export const flatLocalize = {
	successAdd: (name) => `Úspešne ste pridali byt s názvom: ${name}.`,
	successChangedWaterMeters: (flatId) => `Úspešne ste zmenili merače bytu s ID: ${flatId}.`,
	errorChangedWaterMeters: (flatId) => `Nepodarilo sa zmeniť merače bytu s ID: ${flatId}.`,
	errorAssignToUser: (flatId) => `Nepodarilo sa zmeniť priradenie používateľa k bytu s ID: ${flatId}.`,
	errorAssignToEntrance: (flatId) => `Nepodarilo sa zmeniť priradenie vchodu k bytu s ID: ${flatId}.`,
	successAssignToUser: (flatId) => `Úspešne ste zmenili priradenie používateľa k bytu s ID: ${flatId}.`,
	successAssignToEntrance: (flatId) => `Úspešne ste zmenili priradenie vchodu k bytu s ID: ${flatId}.`
}

export const waterMeterLocalize = {
	type: (type) => {
		switch (type) {
			case 'TV':
				return 'Teplá voda'
			case 'SV':
				return 'Studená voda'
			default:
				return 'Neznámy typ'
		}
	},
	successChangedType: 'Úspešne ste zmenili typ merača.',
	retrievingWaterMetersErr: `Nepodarilo sa načítať merače.`,
	retrievingWaterMeterForFilter: `Nepodarilo sa načítať merače pre filter.`,
	noResultsWaterMeters: `Nenašli sa žiadne merače.`,
	deleteSuccess: (dev_eui) => `Úspešne ste odstránili merač DEV_EUI: ${dev_eui}.`,
	deleteError: (dev_eui) => `Nepodarilo sa odstrániť merač DEV_EUI: ${dev_eui}. Prosím skúste to znovu.`,
	moreDetails: 'Vodomery - viac detailov'
}

export const billOfLadingLocalize = {
	errSave: `Nepodarilo sa uložiť nákladový list.`,
	successSave: `Úspešne ste uložili nákladový list.`,
	noResults: `Nenašli sa žiadne nákladové listy.`,
	deleteTitle: 'Odstrániť nákladový list',
	overWriteTitle: 'Prepísať nákladový list - ',
	errDelete: 'Nepodarilo sa odstrániť nákladový list.',
	successDelete: 'Úspešne ste odstránili nákladový list.',
	deleteAreYouSure: 'Ste si istý, že chcete odstrániť tento nákladový list? Táto akcia je nevratná.',
	overWriteAreYouSure: 'Nákladový list pre tento rok už existuje. Chcete ho prepísať?',
	deleteLoading: 'Odstraňujem...',
	saveLoading: 'Ukladám...',
	saveConfirm: 'Uložiť',
	deleteConfirm: 'Potvrdiť',
	createNewBillOfLading: 'Vytvoriť nový nákladový list',
	duplicate: 'Duplikovať',
	billOfLading: 'Nákladový list',
	validationYearRequired: 'Toto pole je povinné.',
	validationYearWrongType: 'Rok musí byť číselná hodnota.',
	validationNumericInvalid: 'Niektoré číselné polia obsahujú neplatnú hodnotu',
	title: (activeYear) => `PODKLADY PRE ROZPOČÍTANIE NÁKLADOV NA TEPLO ZA ROK ${activeYear}`
}

export const prvnLocalize = {
	noResultsPRVNs: `Nenašli sa žiadne PRVN merače.`,
	errGetCoefficients: `Nepodarilo sa načítať koeficient polohy.`,
	errGetRadiators: 'Nepodarilo sa načítať radiátory.',
	errGetPassport: 'Nepodarilo sa načítať montážny protokol.',
	errGetOwnerByEmail: (email) => `Nepodarilo sa načítať používateľa s e-mailom: ${email}.`,
	errSave: `Nepodarilo sa uložiť montážny protokol.`,
	successSave: `Úspešne ste uložili montážny protokol.`,
	successRemoveSignature: `Úspešne ste odstránili podpis zmontážneho protokolu.`,
	errRemoveSignature: `Nepodarilo sa odstrániť podpis z montážneho protokolu.`,
	errScanQRCode: 'Nepodarilo sa prečítať údaje z QR kódu.',
	errIsAccessDeniedCam: 'Prosím povoľte prístup ku kamere.',
	successGenerate: `PDF dokument bol úspešne vygenerovaný.`,
	errGeneratePdf: `Nepodarilo sa vygenerovať PDF dokument.`,
	errSignPdf: `Nepodarilo sa podpísať PDF dokument.`,
	successSignPdf: `PDF dokument bol úspešne podpísaný.`,
	successUpdate: `Úspešne ste aktualizovali montážny protokol.`,
	errUpdate: `Nepodarilo sa aktualizovať montážny protokol.`,
	errDownloadPdf: `Nepodarilo sa stiahnuť PDF dokument.`,
	previewPdfTitle: 'Náhľad montážneho protokolu PRVN',
	errSendEmailSignedPrvn: 'Nepodarilo sa odoslať email s podpísaným PRVN protokolom.',
	warnSupplierEmpty: 'Pole "Zhotoviteľ passportu" nie je vyplnené. Odporúčame ho vyplniť pred generovaním PDF.'
}

export const c5Localize = {
	noResultsSensors: `Nenašli sa žiadne merače.`
}

export const measurementLocalize = {
	deleteSuccess: (ids) => `Úspešne ste odstránili namerané hodnoty s IDs: ${JSON.stringify(ids)}.`,
	deleteError: (ids) => `Nepodarilo sa odstrániť namerané hodnoty s IDs: ${JSON.stringify(ids)}. Prosím skúste to znovu.`,
	testGenSendEmailMeasurementsSuccess: 'Úspešne ste odoslali testovacie emaily o spotrebe.',
	testGenSendEmailMeasurementsError: 'Nepodarilo sa odoslať testovacie emaily o spotrebe',
	genSendEmailMeasurementsSuccess: 'Vygenerovaný súbor meraní .xlsx bol odoslany na Váš e-mail.',
	genSendEmailMeasurementsError: 'Nepodarilo sa odoslať vygenerovaný súbor meraní .xlsx na Váš e-mail.'
}

export const sensorLocalize = {
	sensor: `Merač`,
	prvn: `PRVN`,
	c5: `Teplo`,
	waterMeter: `Vodomer`
}

export const roomTypeLocalize = {
	living_room: 'Obývačka',
	kitchen: 'Kuchyňa',
	bedroom: 'Spálňa',
	bathroom: 'Kúpeľňa',
	hallway: 'Chodba',
	dining_room: 'Jedáleň',
	kids_room: 'Detská izba',
	study: 'Pracovňa',
	pantry: 'Špajza',
	utility_room: 'Technická miestnosť',
	storage_room: 'Sklad',
	guest_room: 'Hosťovská izba',
	toilet: 'WC',
	balcony: 'Balkón',
	terrace: 'Terasa',
	garage: 'Garáž',
	attic: 'Podkrovie',
	basement: 'Suterén',
	laundry_room: 'Práčovňa',
	successChangedRoomType: 'Úspešne ste zmenili typ miestnosti.',
	errChangeRoomType: 'Nepodarilo sa zmeniť typ miestnosti.',
	errRetrievingRoomTypes: 'Nepodarilo sa načítať typy miestností.'
}

export const chirpstackLocalize = {
	instanceChoice: 'Inštancia ChirpStack',
	errRetrievingApplications: 'Nepodarilo sa načítať aplikácie.',
	errRetrievingDeviceProfiles: 'Nepodarilo sa načítať profily zariadení.'
}

export const costAllocationLocalize = {
	newCostAllocation: (entrance) => `Nové rozúčtovanie pre vchod: ${entrance}`,
	detailCostAllocation: (idCostAllocation, entrance) => `Detail rozúčtovania pre vchod: ${entrance}`,
	yearLabel: 'Rok rozúčtovania',
	billOfLadingYearLabel: 'Rok nákladového listu',
	entranceLabel: 'Vchod',
	housingCooperativeLabel: 'Správcovská spoločnosť',
	createdAtLabel: 'Dátum vytvorenia',
	statusApproved: 'Schválené',
	statusPending: 'Čaká na schválenie',
	saveLoading: 'Ukladám...',
	saveConfirm: 'Uložiť',
	saveSuccess: 'Rozúčtovanie bolo úspešne uložené.',
	saveError: 'Nepodarilo sa uložiť rozúčtovanie.',
	noBillOfLading: 'Nie je vybraný nákladový list.',
	generatePreview: 'Generovať náhľad',
	resetPreview: 'Zrušiť náhľad',
	previewGeneratedSuccess: 'Náhľad rozúčtovania bol úspešne vygenerovaný.',
	previewGeneratedError: 'Nepodarilo sa vygenerovať náhľad rozúčtovania.',
	downloadError: 'Nepodarilo sa stiahnuť súbory rozúčtovania.',
	detailLoadError: 'Nepodarilo sa načítať detail rozúčtovania.',
	yearMismatchTitle: 'Nesúlad rokov',
	yearMismatchWarning: (allocationYear, billOfLadingYear) =>
		`Rozúčtovanie za rok (${allocationYear}) sa líši od roku nákladového listu (${billOfLadingYear}). Chcete pokračovať?`,
	yearMismatchConfirm: 'Pokračovať',
	yearMismatchCancel: 'Zrušiť',
	deleteConfirmTitle: 'Odstrániť rozúčtovanie',
	deleteConfirmMessage: (year, entranceName) => `Naozaj chcete odstrániť rozúčtovanie za rok ${year} pre vchod ${entranceName}?`,
	deleteConfirm: 'Odstrániť',
	deleteCancel: 'Zrušiť',
	deleteLoading: 'Odstraňujem...',
	deleteSuccess: 'Rozúčtovanie bolo úspešne odstránené.',
	deleteError: 'Nepodarilo sa odstrániť rozúčtovanie.',
	approveConfirmTitle: 'Schváliť rozúčtovanie',
	approveConfirmMessage: (year, entranceName) =>
		`Naozaj chcete schváliť rozúčtovanie za rok ${year} pre vchod ${entranceName}? Po schválení nebude možné rozúčtovanie upraviť ani odstrániť.`,
	approveConfirm: 'Schváliť',
	approveCancel: 'Zrušiť',
	approveLoading: 'Schvaľujem...',
	approveSuccess: 'Rozúčtovanie bolo úspešne schválené.',
	approveError: 'Nepodarilo sa schváliť rozúčtovanie.',
	measurementsTitle: 'Namerané hodnoty',
	measurementFlatName: 'Byt',
	measurementValueStart: 'Začiatočná hodnota',
	measurementValueEnd: 'Konečná hodnota',
	measurementConsumptionHeating: 'Vykurovacie obdobie',
	measurementConsumptionNonHeating: 'Mimo vykurovacieho obdobia',
	measurementConsumptionTotal: 'Celková spotreba',
	metersCount: 'Počet meračov',
	meterDevEui: 'DevEUI merača',
	flatsLabel: 'bytov',
	// Send email
	sendEmailTitle: 'Odoslať rozúčtovanie na email',
	sendEmailMessage: 'Ste si istí, že chcete odoslať rozúčtovanie na email?',
	sendEmailConfirm: 'Odoslať',
	sendEmailCancel: 'Zrušiť',
	sendEmailLoading: 'Odosielam...',
	sendEmailSuccess: 'Rozúčtovanie bolo úspešne odoslané na email.',
	sendEmailError: 'Nepodarilo sa odoslať rozúčtovanie na email.',
	sendEmailManagerLabel: 'Email správcu:',
	sendEmailNoManagerEmail: 'Email nie je k dispozícii',
	sendEmailAlsoToCurrentUser: 'Odoslať aj na môj email',
	sendEmailNotApprovedTitle: 'Rozúčtovanie nie je schválené',
	sendEmailNotApprovedMessage: 'Pred odoslaním emailu najskôr schváľte rozúčtovanie.',
	sendEmailNoRecipient: 'Vyberte aspoň jedného príjemcu'
}
